// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.small .custom-control-label::before,
.small .custom-control-label::after {
  top: 0.8rem;
  width: 0.75rem;
  height: 0.75rem;
}`, "",{"version":3,"sources":["webpack://./libs/msslib/src/lib/components/checkbox-list/checkbox-list.component.scss"],"names":[],"mappings":"AACE;;EAEE,WAAA;EACA,cAAA;EACA,eAAA;AAAJ","sourcesContent":[".small {\n  .custom-control-label::before,\n  .custom-control-label::after {\n    top: 0.8rem;\n    width: 0.75rem;\n    height: 0.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
